import { Col, Row, Tooltip } from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useGetCategoryBasedAdvertCounts } from "../ServerSideStates";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import CustomNoData from "apps/Common/CustomNoData";
import PageTitle from "apps/Common/PageTitle";

const NumberAdsByCategory = () => {
  const { filter } = useSelector(
    (state: RootState) => state.competitorAnalysisRepor
  );
  const reports = useGetCategoryBasedAdvertCounts(filter);

  return (
    <>
      <Row
        gutter={[20, 20]}
        className="!shadow-lg !rounded-md !p-4 !bg-gray-50"
      >
        <Col span={24} className="!flex !justify-center md:!justify-start" >
          <PageTitle  textClassNames="!text-gray-400" title=" Kategori Bazlı İlan Sayısı" />
        </Col>
        {reports?.data?.data?.length > 0 ? (
          <>
            <Col xs={24}>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={reports?.data?.data.map((item: any) => {
                    return {
                      name: item.categoryType,
                      EmlakOfisim: item.myOfficeCount,
                      BolgeOrtalamasi: item.regionAverage,
                    };
                  })}
                  margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="EmlakOfisim" fill="#90caf9" />
                  <Bar dataKey="BolgeOrtalamasi" fill="#2979ff" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
          </>
        ) : (
          <>
            <div className="!h-[400px] !flex justify-center !w-full">
              <CustomNoData />
            </div>
          </>
        )}
      </Row>
    </>
  );
};

export default NumberAdsByCategory;
